import PropTypes from 'prop-types';
import { forbidExtraProps } from 'airbnb-prop-types';

import { connect } from 'react-redux';
import { useAppSelector } from 'dux/app/hooks';

import { theme } from '@prose-ui';
import { legacyTheme, styled } from '@prose-ui/legacy';
import Image from 'next/image';

import { Typography } from 'Components/Typography';

import { productsCategories } from 'constants/products';

import { subscriptionPerksContent } from 'assets/content/membership/membershipModal';

import useResponsiveVariant from 'utils/useResponsiveVariant';

import { getMembershipPerksTitle, getUserCurrentSubscriptionDiscount } from 'dux/user/selectors';

import { BasicModal } from './BasicModal';
import { PerksContentTitle } from './PerksContentTitle';
import Spacer from './Spacer';

const StyledModal = styled(BasicModal)`
  background-color: ${theme.colors.highlight[200]};
  text-align: center;
  margin-top: auto;
  padding-top: 72px;
  width: 100%;

  ${legacyTheme.breakpoints.up('sm')} {
    min-width: 400px;
    width: auto;
    margin-bottom: -24px;
  }

  ${legacyTheme.breakpoints.up('md')} {
    border-top-left-radius: 20px;
    border-top-right-radius: 20px;
  }
`;

const PerkWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 4px 0px 4px 0px;
`;

const StyledImg = styled(Image)`
  margin-top: -2px;
`;

export const MembershipModal = ({
  category,
  isModalOpen,
  closeModal,
  membershipPerksContentTitle,
}) => {
  const { isMobile } = useResponsiveVariant();
  const subscriptionDiscount = useAppSelector(getUserCurrentSubscriptionDiscount);

  return (
    <StyledModal
      dataFrom="membership-modal"
      isFullWidth={isMobile}
      isOpen={isModalOpen}
      onClose={closeModal}
    >
      <Typography id={isModalOpen ? 'modal-title' : ''} variant="p1">
        <PerksContentTitle
          discount={subscriptionDiscount}
          title={subscriptionPerksContent.title[category][membershipPerksContentTitle]}
          variant={membershipPerksContentTitle}
        />
      </Typography>
      <Spacer size={4} />
      <Typography variant="p1">+</Typography>
      <Spacer size={4} />
      <div id={isModalOpen ? 'modal-description' : ''}>
        {subscriptionPerksContent.content.map(({ logo, text, alt, width, height }) => (
          <PerkWrapper key={text}>
            <StyledImg alt={alt} height={height} src={logo} width={width} />
            <Spacer axis="horizontal" size={12} />
            <Typography variant="p2">{text}</Typography>
          </PerkWrapper>
        ))}
      </div>
    </StyledModal>
  );
};

MembershipModal.propTypes = forbidExtraProps({
  isModalOpen: PropTypes.bool.isRequired,
  category: PropTypes.oneOf([productsCategories.HAIRCARE, productsCategories.SKINCARE]),
  closeModal: PropTypes.func.isRequired,
  membershipPerksContentTitle: PropTypes.string.isRequired,
});

MembershipModal.defaultProps = {
  category: null,
};

export default connect(
  state => ({
    membershipPerksContentTitle: getMembershipPerksTitle(state),
  }),
  {}
)(MembershipModal);
